(function () {

    'use strict';
    angular.module('app')
        .controller('deleteAccountsController', ['$scope', '$uibModalInstance', 'emailToDelete', 'accountIdToDelete', deleteAccountsController]
            );

    function deleteAccountsController($scope, $uibModalInstance, emailToDelete, accountIdToDelete) {
        $scope.model = {};
        $scope.model.email = emailToDelete;
        $scope.model.accountId = accountIdToDelete;

        $scope.ok = function () {
            $scope.model.confirming = true;
        };

        $scope.confirm = function () {
            $uibModalInstance.close({ delete: true, accountId: $scope.model.accountId });
        };

        $scope.cancel = function () {
            $uibModalInstance.close({ delete: false });
        };
    }

})();